import React, { useState } from "react";
// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import ReactBSAlert from "react-bootstrap-sweetalert";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import dateFormat from "dateformat";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import DatePicker from "react-datepicker";
import Button from "@material-ui/core/Button";
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";

import {
  getAmenitiesLog
} from "../../network/ApiAxios";
import { redirectToLogout,zeroFill,dateSortFunc,
//  numericSortFunc,slotDateSortFunc
 } from "common/SharedFn";


const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPage:50,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="500">500</option>
            <option value="1000">1000</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const AmenitiesTable = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const [alert, setAlert] = React.useState(false);
  const componentRef = React.useRef(null);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [success, setSuccess] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [id, setId] = useState();
  const [forceRefresh, setForceRefresh] = useState(false);
  const [ids, setIds] = useState([]);
  const [selectedCount, setSelectedCount] = useState(0);

  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    style: { backgroundColor: "#c8e6c9" },
    onSelect: (row, isSelect, rowIndex, e) => {
      if (isSelect) {
        ids.push(row.id);
      } else {
        var index = ids.indexOf(row.id);
        if (index !== -1) {
          ids.splice(index, 1);
        }
      }
      setSelectedCount(ids.length);
    },
    onSelectAll: (isSelect, rows, e) => {
      if (isSelect) {
        for (var i = 0; i < rows.length; i++) {
          ids.push(rows[i].id);
        }
      } else {
        for (var i = 0; i < rows.length; i++) {
          var index = ids.indexOf(rows[i].id);
          if (index !== -1) {
            ids.splice(index, 1);
          }
        }
      }
      setSelectedCount(ids.length);
    },
  };

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const fetchAmenities = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    setData([]);
    try {
      const response = await getAmenitiesLog(startDate, endDate);
      const { data } = response;
      if (data.result.isSuccess) {
        setData(data.data.map((prop) => makeTableRow(prop)));
        //setError("");
      } else {
        showErrorNotification(data.result.description);
        if (data.result.code == -2) {
          redirectToLogout();
        }
      }
    } catch (ex) {
      showErrorNotification("Failed to fetch amenities "+ex);
    }
    setIsLoading(false);
  };

  useAsyncEffect(async () => {
    if (endDate == null) {
      var endDateStored = localStorage.getItem("searchEndDate");
      if(endDateStored != null && endDateStored.toUpperCase() !== "NULL"){
        setEndDate(new Date(endDateStored));
      }
      else{
        setEndDate(new Date());
      }
    }
    if (startDate == null) {
      var startDateStored = localStorage.getItem("searchStartDate");
      if(startDateStored != null && startDateStored.toUpperCase() !== "NULL"){
        setStartDate(new Date(startDateStored));
      }
      else{
        setStartDate(new Date().setDate(new Date().getDate() - 7));
      }
    }
      if (startDate != null && endDate != null  ) {
        fetchAmenities();
      }
  }, [
    forceRefresh,
    startDate,
    endDate,
  ]);

  const makeTableRow = (info) => {
    
    info.recordDatetimeText = dateFormat(
      new Date(info.recordDatetime),
      "d-mmm-yyyy hh:MM TT"
    );
    return {
      ...info,
      idForm: (
        "A"+zeroFill(info.id,5)
      ),
      userIdForm: (
        "C"+zeroFill(info.userId,5)
      ),
      driverIdForm: (
        "D"+zeroFill(info.driverId,5)
      )
    };
  };

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>
              <CardHeader
                subheader={
                  <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Box component="span">Amenities</Box>
                    </Box>
                  </>
                }
                classes={{ root: classes.cardHeaderRoot }}
              ></CardHeader>

              <ToolkitProvider
                data={data}
                keyField="id"
                columns={[
                  {
                    dataField: "idForm",
                    text: "ID",
                    sort: true,
                  },
                  {
                    dataField: "item",
                    text: "Item",
                    sort: true,
                  },
                  {
                    dataField: "quantity",
                    text: "Quantity",
                    sort: true,
                  },
                  {
                    dataField: "userIdForm",
                    text: "User ID",
                    sort: true,
                  },
                  {
                    dataField: "driverIdForm",
                    text: "Driver ID",
                    sort: true,
                  },
                  {
                    dataField: "recordDatetimeText",
                    text: "Delivered On",
                    sort: true,
                    sortFunc: dateSortFunc,                    
                  },
                ]}
                search
                exportCSV
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <Grid container className="pl-4">
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        style={{ marginBottom: "15px" }}
                      >
                        <ExportCSVButton
                          className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedSizeSmall MuiButton-sizeSmall"
                          {...props.csvProps}
                        >
                          <span className="MuiButton-label">Download</span>
                        </ExportCSVButton>
                        <Button></Button>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div
                          id="datatable-basic_filter"
                          className="dataTables_filter px-4 pb-1 float-right"
                        >
                          <label>
                            Search:
                            <SearchBar
                              className="form-control-sm"
                              placeholder=""
                              {...props.searchProps}
                            />
                          </label>
                        </div>
                      </Grid>
                    </Grid>

                    <Grid container className="pl-4">
                      <Grid item xs={12} sm={12}>
                        <form>
                          View From &emsp;
                          <div style={{ display: "inline-block" }}>
                            <DatePicker
                              timeCaption="Start Date"
                              selected={startDate}
                              customInput={<OutlinedInput />}
                              onChange={(date) => {
                                localStorage.setItem("searchStartDate", date);
                                setStartDate(date);}}
                              dateFormat="dd-MM-yyyy"
                            />
                          </div>{" "}
                          &emsp; to &emsp;
                          <div style={{ display: "inline-block" }}>
                            <DatePicker
                              timeCaption="End Date"
                              selected={endDate}
                              customInput={<OutlinedInput />}
                              onChange={(date) => {
                              localStorage.setItem("searchEndDate", date);
                                setEndDate(date);
                              }}
                              dateFormat="dd-MM-yyyy"
                            />
                          </div>{" "}
                        </form>
                      </Grid>
                    </Grid>
                    <Grid container className="pl-4">
                      <Grid item xs={12} sm={12}>
                        <div
                            style={{
                              marginBottom: "20px",
                            }}
                          >
                        {selectedCount} Rows Selected
                        </div>
                      </Grid>
                    </Grid>
                    <BootstrapTable
                      ref={componentRef}
                      {...props.baseProps}
                      bootstrap4={true}
                      pagination={pagination}
                      bordered={true}
                      striped={true}
                      selectRow={selectRow}
                      noDataIndication={() =>
                        isLoading ? (
                          <Box
                            component={Grid}
                            container
                            justifyContent="center"
                            className="justify-content-center"
                          >
                            <div
                              className="text-center"
                              style={{ width: "20%" }}
                            >
                              <LoadingAnimation />{" "}
                            </div>
                          </Box>
                        ) : (
                          <h4>No Records</h4>
                        )
                      }
                      id="main-table"
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Card>
          </Grid>
        </Grid>
        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default AmenitiesTable;
